import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";

import { BaseRequirementDefinitionFormValues } from "../types";
import { RequirementExpirationStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";

export const getBaseEditValues = (
  requirementDefinition: IRequirementDefinitionResponse
): BaseRequirementDefinitionFormValues => ({
  description: requirementDefinition.description,
  expirationDays: requirementDefinition.expirationDays ?? 30,
  expirationStrategy:
    requirementDefinition.expirationStrategy ??
    RequirementExpirationStrategy.None,
  isApprovalRequired: requirementDefinition.reviewStrategy !== "NeverRequired",
  manualRenewalAllowed: requirementDefinition.manualRenewalAllowed ?? false,
  name: requirementDefinition.name,
  reviewStrategy: requirementDefinition.reviewStrategy,
  type: requirementDefinition.requirementType
});
